import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { userLoggedIn } from "../features/auth/authSlice";

export default function useAuthCheck() {
    const [authCheck, setAuthCheck] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const localAuth = localStorage?.getItem("_auth");
        if (localAuth) {
            const auth = JSON.parse(localAuth);
            if (auth?.accessToken && auth?.user) {
                dispatch(
                    userLoggedIn({
                        accessToken: auth.accessToken,
                        user: auth.user,
                    })
                );
            }
        }
        return setAuthCheck(true);
    }, [dispatch]);

    return authCheck;
}
